/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/110-bubbles2': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" d="M7.5 0C11.642 0 15 2.717 15 6.069s-3.358 6.069-7.5 6.069a9.16 9.16 0 01-1.169-.074C4.72 13.669 2.86 13.956 1 13.999v-.393c1.004-.49 1.813-1.382 1.813-2.402 0-.142-.011-.282-.032-.419C1.085 9.672 0 7.973 0 6.068 0 2.716 3.358-.001 7.5-.001zm8.063 13.604c0 .874.567 1.639 1.438 2.059V16c-1.611-.036-3.09-.283-4.487-1.658-.33.041-.669.063-1.013.063-1.492 0-2.866-.402-3.963-1.079 2.261-.008 4.395-.732 6.013-2.042a7.346 7.346 0 001.913-2.302 6.23 6.23 0 00.704-3.4C17.302 6.518 18 7.795 18 9.202c0 1.633-.94 3.089-2.41 4.043a2.361 2.361 0 00-.027.359z"/>'
  }
})
